import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './index.module.scss';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen]);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/support', label: 'Support' },
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/terms-condition', label: 'Terms & Condition' }
  ];

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <img
            src="/Lumida-Invest-White-Logo.webp"
            alt="Lumida Invest"
            className={styles.logo}
            onClick={() => navigate('/')}
          />
          <nav className={styles.desktopNav}>
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <span
                  key={item.path}
                  className={`${styles.navLink} ${isActive ? styles.active : ''}`}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </span>
              );
            })}
          </nav>
          {/* <button
            className={`${styles.hamburger} ${isMobileMenuOpen ? styles.open : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button> */}
        </div>
      </header>

      {/* Mobile overlay */}
      {/* <div
        className={`${styles.mobileOverlay} ${isMobileMenuOpen ? styles.open : ''}`}
        onClick={toggleMobileMenu}
      /> */}

      {/* Mobile nav drawer */}
      {/* <nav className={`${styles.mobileNav} ${isMobileMenuOpen ? styles.open : ''}`}>
        <div className={styles.mobileHeader}>
          <img src="/Lumida-Invest-White-Logo.webp" alt="Lumida Invest" className={styles.mobileLogo} />
          <button className={styles.mobileCloseBtn} onClick={toggleMobileMenu} aria-label="Close menu">
            &times;
          </button>
        </div>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <div
              key={item.path}
              className={`${styles.mobileTab} ${isActive ? styles.active : ''}`}
              onClick={() => {
                navigate(item.path);
                setIsMobileMenuOpen(false);
              }}
            >
              {item.label}
            </div>
          );
        })}
      </nav> */}

      <div className={styles.spacer} />
    </>
  );
};

export default Header;
